<script setup>
import SegmentationCustomerTable from '@frontJs/components/tables/projectManagement/sem/SegmentationCustomerTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, semSegmentation } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    semSegmentation: {
        type: Object,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Clients - Segmentation #{{ semSegmentation.id }} - SEM - Gestion de
            projet - Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - SEM - Segmentation #{{ semSegmentation.id }} -
        Clients
    </PageTitle>

    <SegmentationCustomerTable
        :tenant="tenant"
        :semSegmentation="semSegmentation"
    />
</template>
